"use strict";

require("core-js/stable");

require("regenerator-runtime/runtime");

var _history = require("history");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Root = _interopRequireDefault(require("./Root"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (module.hot) {
  module.hot.accept();
}

var history = (0, _history.createBrowserHistory)();

_reactDom.default.render(_react.default.createElement(_Root.default, {
  history: history
}), document.getElementById('root'));


//////////////////
// WEBPACK FOOTER
// ./lib/app/index.js
// module id = 82
// module chunks = 0